import React from 'react'
import Collapsible from 'react-collapsible'
import ReportAll from './ReportAll'
import TableReportAll from './TableReportAll'
import { checkTranslation, conditionalWidth, msToHMS, translate } from '../utils/useful'
import Responsive from './Responsive'
import moment from 'moment'
import ButtonAnimated from './buttons/ButtonAnimated'
import StagesManager from './StagesManager'
import NewInquiry from '../windows/Applets/inquiries/NewInquiry'
import CustomLoader from './CustomLoader'
import HttpServices from '../utils/Http.services'

class Reports extends React.Component {
    state = {
        questions: [
            { name: 'Question 1', scores: { 1: 5, 2: 10, 3: 1, 4: 3 }, average: '3.5', max: '7' },
            { name: 'Question 2', scores: { 1: 8, 2: 2, 3: 10, 4: 12 }, average: '5', max: '6' },
            { name: 'Question 3', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
            { name: 'Question 4', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
            { name: 'Question 5', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
            { name: 'Question 6', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
            { name: 'Question 7', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
            { name: 'Question 8', scores: { 1: 5, 2: 12, 3: 4, 4: 0 }, average: '3.5', max: '7' },
        ],
        tabs: [
            { name: '{{lang}}Details', key: 'details' },
            { name: '{{lang}}Results', key: 'results' },
            { name: '{{lang}}Charts', key: 'charts' }
        ],
        currentTab: 'details',
        isOpen: {},
        editForm: true,
        participantsHeaders: [],
        participants: [],

    }

    componentDidMount = () => {
        // if (this.props.editInquiry) {
        //     console.log('editInquiryasdqqq')
        //     if (this.props.setHeader) {
        //         this.props.setHeader({
        //             'toolbar': null,
        //             'showToolbar': false,
        //             // topHeaderComponent: this.topHeaderComponent,
        //             // title: '{{lang}}Edit Inquery',
        //             // headerIdentityComponent: this.headerIdentityComponent,
        //             backAction: () => { this.props.changePage(this.props.collectionId); this.props.setData('editInquiry', false, 'CollectionView') }
        //         })
        //     }
        // }
        // if (this.props.data.values.time) {
        //     let time = String((Number(this.props.data.values.time[0]) * 3600) + (Number(this.props.data.values.time[1]) * 60) + (Number(this.props.data.values.time[2]) * 1))
        //     this.setState({ time }, () => {
        //     })
        // }
        let isOpen = this.state.isOpen
        for (let i = 0; i < this.state.questions.length; i++) {
            isOpen[i] = true
        }
        this.setState({ isOpen })

        this.getParticipants()
        // this.props.setHeader({
        //     // 'toolbar': null,
        //     'showToolbar': true,
        //     // topHeaderComponent: this.topHeaderComponent,
        //     // title: '{{lang}}New Inquery',
        //     // headerIdentityComponent: this.headerIdentityComponent,
        //     backAction: () => this.props.changePage(this.props.collectionId)

        // })
        console.log('shfsifis', this.props)
        let windowData = this.props.windowData
        let recordId = windowData[windowData.length - 1]
        this.setState({ recordId })
    }
    componentDidUpdate() {

    }
    getParticipants = () => {
        HttpServices.request('getParentFrame', { id: this.props.page._id, slug: 'participations', isDefault: true }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let participantsHeaders = fetchResult.info?.fields ?? []

            HttpServices.request('getRecords', { frame: fetchResult?.info?._id ?? this.props.page._id, applet: this.props.applet?._id, populateKey: 'values.quiz', populateValue: this.props.currentItem?._id }, (sFetchResult, sFetchError) => {
                console.log('sFetchResult.info', sFetchError)
                if (sFetchError) {
                    return
                }
                console.log('sFetchResult.info', sFetchResult.info)

                let participants = sFetchResult.info
                this.setState({ participantsHeaders, participants })
            })
        })
    }
    changeCollapse = (item, index) => {
        let isOpen = this.state.isOpen
        // isOpen = {}
        isOpen[index] = !isOpen[index]

        this.setState({ isOpen })
        // this.props.changeAppletsTab(item, index)
    }

    // changeAppletsTab = (item) => {
    //     this.setState({ currentApplet: item })
    // }

    // setData = (key, value) => {
    //     this.setState({ [key]: value })
    // }

    changeTab = (item) => {
        // console.log('this.props',this.props)
        if (this.props.editInquiry) {
            switch (item) {
                // case 'details':
                //     if (this.props.setHeader) {
                //         this.props.setHeader({
                //             'toolbar': null,
                //             'showToolbar': false,
                //             // topHeaderComponent: this.topHeaderComponent,
                //             // title: '{{lang}}Edit Inquery',
                //             // headerIdentityComponent: this.headerIdentityComponent,
                //             backAction: () => {
                //                 this.props.changePage(this.props.collectionId);
                //                 this.props.setData('editInquiry', false, 'CollectionView');
                //                 this.props.defaultCollectionHeader()
                //             }
                //         })
                //     }   
                //     break;

                case 'results':
                    if (this.props.setHeader) {
                        this.props.setHeader({
                            'toolbar': null,
                            'showToolbar': false,
                            // topHeaderComponent: this.topHeaderComponent,
                            // title: '{{lang}}Edit Inquery',
                            // headerIdentityComponent: this.headerIdentityComponent,
                            backAction: () => {
                                this.props.changePage(this.props.collectionId);
                                this.props.setData('editInquiry', false, 'CollectionView');
                                this.props.defaultCollectionHeader()
                            }
                        })
                    }
                    break;

                case 'charts':
                    if (this.props.setHeader) {
                        this.props.setHeader({
                            'toolbar': null,
                            'showToolbar': false,
                            // topHeaderComponent: this.topHeaderComponent,
                            // title: '{{lang}}Edit Inquery',
                            // headerIdentityComponent: this.headerIdentityComponent,
                            backAction: () => {
                                this.props.changePage(this.props.collectionId);
                                this.props.setData('editInquiry', false, 'CollectionView');
                                this.props.defaultCollectionHeader()
                            }
                        })
                    }
                    break;

                default:
                    break;
            }
        }

        this.setState({ currentTab: item })
    }

    EditInquiry = () => {
        this.setState({ isLoading: true })
        if (this.props.data.values) {
            this.stagesManager.changeStage('newInquery')
            this.setState({ isLoading: false })
        }
        else {
            this.setState({ isLoading: false })

        }
    }
    getTeacherName = (teacher) => {
        if (this.props.data.populates.users) {
            return this.props.data.populates.users.map((element) => {
                if (element._id == teacher) {
                    return element.fullname
                }
            })
        }
    }
    changeReportPage = (stage) => {
        this.stagesManager.changeStage(stage)
    }

    render() {
        return (
            <div className='h-100 w-100'>
                <div className="w-100 flexc py-2 px-3 overflow-auto sc-gray2" style={{ zIndex: 9, backgroundColor: '#fff' }}>
                    {Array.isArray(this.state.tabs) && this.state.tabs.map((tab, index) => {
                        return (
                            <button key={index} className={" flexcc cursor-pointer py-2 mrd-2 px-3 "} onClick={() => { this.changeTab(tab.key) }} style={{ borderBottom: this.state.currentTab == tab.key ? `2px solid ${this.props.colors?.primaryColor}` : '2px solid transparent', color: this.state.currentTab == tab.key ? this.props.colors?.primaryColor : '#777' }}>
                                <p className="weight-600 font-size-13 text-center" style={{}}>{checkTranslation(tab.name)}</p>
                            </button>
                        )
                    })}
                </div>
                <div className='w-100 scroll-no-scrollbar' style={{ height: 'calc(100% - 52px)' }}>
                    {this.state.currentTab == 'charts' &&
                        <div className='py-4 w-100'>
                            <p className="font-size-18 weight-500 mx-2" style={{ color: '#000' }}>{translate('Reports')}</p>
                            <div className='d-flex flex-wrap mt-3'>
                                {this.state.questions.map((data, index) => {
                                    return (
                                        <Responsive width={this.props.width} media={{ xs: '12', sm: '12', md: '12', lg: '6' }}>
                                            <div className='bb-gray w-100' style={{}}>
                                                <div className='px-2 w-100' style={{}} onClick={() => this.changeCollapse(data, index)} >
                                                    <button className='flexcb p-2 w-100 hover-questions br-10 mb-2' style={{}} >
                                                        <div className='flexc'>
                                                            <img className='mrd-2 flexcc' width={20} src='/assets/icons/question-green.svg' />
                                                            <p className='main-c3'>{checkTranslation(data.name)}</p>
                                                        </div>
                                                        <button>
                                                            <img width={22} className={'flexcc ' + (this.state.isOpen[index] ? 'rotate-180' : '')} src='/assets/icons/arrow-up-green.svg' />
                                                        </button>
                                                    </button>
                                                </div>
                                                <Collapsible open={this.state.isOpen[index]} transitionTime={500}>
                                                    <ReportAll width={this.props.width} data={data} index={index} item={this.state.questions} />
                                                </Collapsible>
                                            </div>
                                        </Responsive>
                                    )
                                })}
                            </div>
                        </div>
                    }
                    {this.state.currentTab == 'results' &&
                        <div className='my-4 w-100'>
                            <TableReportAll applet={this.props.applet} headers={this.state.participantsHeaders} language={this.props.language} width={this.props.width} data={this.state.participants} />
                        </div>
                    }
                    {this.state.currentTab == 'details' &&
                        (this.props.data && Object.values(this.props.data).length > 0) ?
                        <div className='h-100'> 
                            <NewInquiry stageName={'newInquery'}
                                permissions={this.props.permissions}
                                baseUrl={[...this.props.baseUrl]}
                                participation={this.props.participation}
                                data={this.props.data}
                                initData={this.props.data}
                                ref={el => this.collectionView = el}
                                setData={this.props.setData}
                                setHeader={this.props.setHeader}
                                colors={this.props.colors}
                                width={this.props.width}
                                height={this.props.height}
                                formPages={this.props.formPages}
                                changePage={this.props.changePage}
                                addNotif={this.props.addNotif}
                                page={this.props.page}
                                windowData={this.props.windowData}
                                applet={this.props.applet}
                                headers={this.props.headers}
                                automations={this.props.automations}
                                language={this.props.language}
                                userSettings={this.props.userSettings}
                                lastStagePage={this.props.lastStagePage}
                                changeWindowLink={this.props.changeWindowLink}
                                changeStage={this.props.changeStage}
                                goToHub={this.props.goToHub}
                                variables={this.props.variables}
                                collectionId={this.props.collectionId}
                                editForm={this.state.editForm}
                                changeReportPage={this.changeReportPage}
                                editInquiry={this.props.editInquiry}
                                defaultCollectionHeader={this.props.defaultCollectionHeader}
                            />
                        </div>
                        :
                        <div className='w-100 h-100 flexcc'>
                            <div className='flexcc ' style={{ width: '28px', aspectRatio: '1 / 1' }}>
                                <CustomLoader color={this.props.colors ? this.props.colors.primaryColor : '#222'} isLoading={true} width={27} type={"Oval"} className={'flexcc'} />
                            </div>
                        </div>
                    }
                </div>
                {/* </StagesManager> */}
            </div>
        )
    }
}

export default Reports;